import { render } from "./ChooseTaskAssessmentModal.vue?vue&type=template&id=37bf2fdc&scoped=true"
import script from "./ChooseTaskAssessmentModal.vue?vue&type=script&lang=js"
export * from "./ChooseTaskAssessmentModal.vue?vue&type=script&lang=js"

import "./ChooseTaskAssessmentModal.vue?vue&type=style&index=0&id=37bf2fdc&scoped=true&lang=css"
/* custom blocks */
import block0 from "./ChooseTaskAssessmentModal.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bf2fdc"]])

export default __exports__